import script from "./GroupTextComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupTextComponent.vue?vue&type=script&setup=true&lang=js"

import "./GroupTextComponent.vue?vue&type=style&index=0&id=709794a6&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709794a6"]])

export default __exports__